<span>
  <img [class.disabled]="!enable" src="assets/images/logos/tiktok.png">
</span>
